var render = function render(_c,_vm){return _c(_vm.props.tag ?? 'div',{tag:"component"},[_vm._l((String(_vm.props.value).split('\n')),function(line,i){return [_vm._v("\n        "+_vm._s(line)),(i < String(_vm.props.value).split('\n').length - 1)?_c('br',{key:i}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }